import React from "react";
import "./Main.css";

const TEXT = "31 de OCTUBRE — RAFAELA — SANTA FE — ";

class Marquee extends React.Component {
  render() {
    return (
      <div className="tera-marquee">
        <div className="tera-marquee-track">
          <span>{TEXT.repeat(6)}</span>
          <span>{TEXT.repeat(6)}</span>
        </div>
      </div>
    );
  }
}

export default Marquee;
